// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audio-box {\n  width: 70%;\n}\n.audio-box .custom-button {\n  width: 0.69333rem;\n  color: #fff;\n  font-size: 0.26667rem;\n  line-height: 0.48rem;\n  text-align: center;\n  background-color: #ee0a24;\n  border-radius: 2.66667rem;\n}\n.audio-box .van-slider {\n  background-color: rgba(255, 255, 255, 0.2) !important;\n}\n", ""]);
// Exports
module.exports = exports;
